export default {
  title: 'Aplicație mobilă',
  fields: {
    name: 'Numele aplicației',
  },
  buttons: {
    save: 'Salvează',
  },
};
